import "./WeekSelector.scss"

type Props = {
  weekOffset: number
  onChange: (offset: number) => void
}

export function WeekSelector({ weekOffset, onChange }: Props) {
  return (
    <div className="WeekSelector">
      {weekOffset <= -2 && (
        <button
          className="WeekSelector__button"
          onClick={() => onChange(0)}
          aria-label="Previous week"
        >
          Reset
        </button>
      )}
      <button
        className="WeekSelector__button"
        onClick={() => onChange(weekOffset - 1)}
        aria-label="Previous week"
      >
        ‹
      </button>
      <button
        className="WeekSelector__button"
        onClick={() => onChange(weekOffset + 1)}
        disabled={weekOffset >= 0}
        aria-label="Next week"
      >
        ›
      </button>
    </div>
  )
}
